import { useMemo } from 'react';

import { RESOURCE_CONTENT_TYPE, VISIBLE_RESOURCE_CONTENT_TYPES } from 'src/data/performance';

/**
 * Prepares the list of visible resource content types, optionally including audio and video resources.
 *
 * @param {boolean} shouldIncludeAudioVideoResources - Determines whether audio and video resources should be included.
 * @returns {string[]} An array of visible resource content types.
 */
export const usePrepareVisibleResourcesContentTypes = (shouldIncludeAudioVideoResources) => {
  return useMemo(
    () =>
      shouldIncludeAudioVideoResources
        ? [
            ...VISIBLE_RESOURCE_CONTENT_TYPES,
            RESOURCE_CONTENT_TYPE.audio,
            RESOURCE_CONTENT_TYPE.video,
          ]
        : VISIBLE_RESOURCE_CONTENT_TYPES,
    [shouldIncludeAudioVideoResources]
  );
};
